export default __webpack_public_path__ + "static/media/title-input.173414a2.png";